<template>
	<div ref="tablePage" style="height: 100%">
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>财务概览</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</div>
		<el-card style="margin-top: 10px;padding: 10px 10px;border-radius: 10px;">
			<el-descriptions title="财务概览">
			</el-descriptions>
			<el-row style="display: flex;align-items: center; justify-content: space-between;">
				<!-- 新增：年度总收入 -->
				<el-col :span="4">
					<el-card class="card-custom bg-overdue-card-purple">
						<h6>本年度合同总收入</h6>
						<h2 class="color-purple">¥ {{dashData.annualTotal}}</h2>
						<small>{{pYear}}全年总盘子 (应收)</small>
					</el-card>
				</el-col>

				<!-- 原有指标：本月待收 -->
				<el-col :span="4">
					<el-card class="card-custom bg-overdue-card-blue">
						<h6>本月待收总款</h6>
						<h2 class="color-blue">¥ {{dashData.monthTotal}}</h2>
						<small>本月资金池</small>
					</el-card>
				</el-col>

				<!-- 原有指标：本月已收 -->
				<el-col :span="4">
					<el-card class="card-custom bg-overdue-card-green">
						<h6>本月已收款</h6>
						<h2 class="color-green">¥ {{dashData.rMonth}}</h2>
						<small><i></i> 实际入账</small>
					</el-card>
				</el-col>

				<!-- 原有指标：本月未收 -->
				<el-col :span="4">
					<el-card class="card-custom bg-overdue-card-orange">
						<h6>本月未收款</h6>
						<h2 class="color-orange">¥ {{dashData.uMonth}}</h2>
						<small>正常待办</small>
					</el-card>
				</el-col>

				<!-- 原有指标：往期欠款 -->
				<el-col :span="4">
					<el-card class="card-custom bg-overdue-card-red">
						<h6><i></i> 往期/上月欠款</h6>
						<h2 class="color-red">¥ {{dashData.overdue}}</h2>
						<small>风险坏账</small>
					</el-card>
				</el-col>
			</el-row>
			<el-descriptions title="近期收款监控中心">
			</el-descriptions>
			<el-tabs v-model="searchForm.filter_type" @tab-click="handleTabClick">
				<el-tab-pane label="全部款项" name="all"></el-tab-pane>
				<el-tab-pane label="本月应收款" name="month_plan"></el-tab-pane>
				<el-tab-pane label="本月已收款" name="month_received"></el-tab-pane>
				<el-tab-pane label="本月未收款" name="month_unpaid"></el-tab-pane>
				<el-tab-pane name="overdue"><span slot="label"><i class="el-icon-bell"></i> 往期/上月欠款</span></el-tab-pane>
			</el-tabs>
			<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini"
				:header-cell-style="{background: '#fff',height: '50px',color: '#909399',fontSize: '16px',fontFamily: 'Arial, sans-serif'}">
				<el-table-column sortable label="截止日期" prop="payment_date" align="center">
					<template slot-scope="scope">
						<div :style="scope.row.status=='overdue'?{'color':'#dc3545'}:''">{{scope.row.payment_date}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="project_name" label="项目名称" align="center" />
				<el-table-column prop="csm" label="经理" align="center" />
				<el-table-column prop="payment_name" label="款项名称" align="center" />
				<el-table-column prop="amount" sortable label="金额" align="center" />
				<el-table-column label="状态" align="center">
					<template slot-scope="scope">
						<div :class="'status-'+scope.row.status" style="width: 50%;margin-left: 25%;">
							{{scope.row.status_name}}
						</div>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" align="center">
					<template slot-scope="scope">
						<el-button v-if="scope.row.status != 'paid'" @click.native.prevent="handleClick(scope.row)"
							type="primary" size="small">
							到账
						</el-button>
						<div v-else>-</div>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		dashBoard,
		payNodes,
		payDone
	} from "../../api/hetong";

	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 请求地址api
				api: {
					list: payNodes,
				},
				// 规则验证
				rules: {
					amount: [{
						required: true,
						message: "请输入金额",
						trigger: "blur"
					}],
				},
				// 传参
				form: {},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					filter_type: 'all'
				},
				regionArr: [],
				dashData: {
					annualTotal: 0,
					monthTotal: 0,
					rMonth: 0,
					uMonth: 0,
					overdue: 0
				},
				pYear: 2025
			};
		},
		mounted() {
			dashBoard().then((res) => {
				this.dashData = res.data;
			});
			const pDate = new Date();
			this.pYear = pDate.getFullYear();
		},
		methods: {

			handleTabClick(tab, event) {
				this.searchForm.filter_type = tab.name;
				this.initList();
			},
			async initList() {
				let fn = this.api.list
				this.tableListLoading = true
				this.tableSelected = []
				await fn(this.searchForm).then((res) => {
					this.tableList = res.data
				}).catch((err) => {

				})
			},
			searchXiaoquClearInput() {
				this.searchForm.xiaoqu_id = '';
				this.searchChange();
			},
			findXiaoqu(xiaoqu_id) {
				let xiaoqu = this.regionArr.find(item => item.xiaoqu_id == xiaoqu_id);
				return xiaoqu ? xiaoqu.xiaoqu_name : '';
			},
			// 重置
			reset() {
				this.form = {};
			},
			// 修改弹窗
			handleClick(row) {
				payDone(row.id).then(res => {
					this.initList();
				});
			},
			// 点击确定
			submitForms() {
				console.log('===================form:', this.form)
				try {
					// 提交表单
					this.submitForm(this.form);
				} catch (error) {
					// 处理提交失败的情况
					this.$message.error('提交失败');
					console.error("提交失败:", error);
					// 执行适当的操作，例如显示错误提示信息或进行其他处理
				}
			},
			// 关闭复制弹窗
			copyout() {
				this.copyIf = false;
				this.$refs.copyForm.clearValidate();
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$refs.form.clearValidate();
			},
		},
	};
</script>

<style>
	.status-overdue {
		background-color: #dc3545;
		color: #ffffff;
		border-radius: 3px;
	}

	.status-paid {
		background-color: #198754;
		color: #ffffff;
		border-radius: 3px;
	}

	.status-unpaid {
		background-color: #fd7e14;
		border-radius: 3px;
	}

	.card-custom {
		border: none;
		box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
		border-radius: 10px;
		margin-bottom: 20px;
		background: white;
		padding: 10px;
		height: 100%;
	}

	.color-purple {
		color: #6610f2;
	}

	/* 年度 */
	.color-blue {
		color: #0d6efd;
	}

	/* 本月应收 */
	.color-green {
		color: #198754;
	}

	/* 本月已收 */
	.color-orange {
		color: #fd7e14;
	}

	/* 本月未收 */
	.color-red {
		color: #dc3545;
	}

	.bg-overdue-card-red {
		background-color: #ffffff;
		border-left: 5px solid #dc3545 !important;
	}

	.bg-overdue-card-orange {
		background-color: #ffffff;
		border-left: 5px solid #fd7e14 !important;
	}

	.bg-overdue-card-green {
		background-color: #ffffff;
		border-left: 5px solid #198754 !important;
	}

	.bg-overdue-card-blue {
		background-color: #ffffff;
		border-left: 5px solid #0d6efd !important;
	}

	.bg-overdue-card-purple {
		background-color: #ffffff;
		border-left: 5px solid #6610f2 !important;
	}

	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	/deep/ .right-aligned-input .el-input__inner {
		text-align: right;
	}

	/deep/ .right-aligned-input .el-input__suffix {
		right: 0;
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/hetong/yingshou.vue